<template>
  <div class="non-blocking-modal">
    <div class="row mb-2">
      <div class="col">
        <h4>Job updates</h4>
        <div class="l-modal-close"
             @click="$emit('close')"
        >
          <button class="btn btn-close"><span class="mod-icon-close opacity-50" /></button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <template v-if="loading">
          <vue-content-loading :width="420" :height="100">
            <rect v-for="x in 2" :key="x" x="10" :y="10*x*3" rx="3" ry="3" width="400" height="15" />
          </vue-content-loading>
        </template>
        <p v-else v-for="change in changes" :key="change.id">{{ change }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <error-field :errors="errors" field="note" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button v-if="sending"
                type="button"
                class="btn btn-primary pull-right ld-ext-right"
                @click="sendUpdateEmail"
        >
          Send email with updates
          <div class="ld ld-ball ld-flip" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Errors from '../../../classes/Errors';
import ErrorField from '../../ErrorField';

export default {
  name: 'JobChanges',
  label: { type: String, default: 'Browse' },
  components: {
    ErrorField,
  },
  props: {
    changes: {
      type: Array,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    modelId: {
      type: Number,
      required: true,
    },
    sending: {
      type: [Boolean, Number],
      default: false,
    },
  },
  data: () => ({
    errors: new Errors(),
  }),
  methods: {
    sendUpdateEmail() {
      axios
        .post(`jobs/${this.modelId}/mails/updated`)
        .then(() => {
          toastr.success('Successfully sent update email');
          this.$emit('ok');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/jobs/modals/JobChanges.vue